import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, pipe } from 'rxjs';
import { map, catchError, retryWhen, delay, take, tap, finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthenticationCheckService } from '../auth/authentication-check.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastClientService } from '../toast/toast-client.service';
import { Router } from '@angular/router';
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  /**
  * Whenever calling Api this interceptor will inject AUTH_Token and enable loader
  */
  constructor(private auth: AuthenticationCheckService, private ngxService: NgxUiLoaderService, private toast: ToastClientService, private router: Router) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const disableloader = request.headers.get('skip');
    const token = this.auth.getAuthToken();

    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: token
        }
      });
    }

    request = request.clone({
      headers: request.headers.set('Accept', 'application/json')
    });

    if (disableloader !== 'true') {
      this.ngxService.start();   // START loader
    }

    return next.handle(request).pipe(

      catchError((error: HttpErrorResponse) => {
        let toasterMessage = 'Something went wrong';

        if (error.error.data.message) {
          toasterMessage = error.error.data.message;
        }

        this.toast.Error(toasterMessage.replace(/"/g, ''));

        const msg = toasterMessage.toLowerCase();

        if (
          msg === 'no access to this module' ||
          msg === 'unauthorized user access!!' ||
          msg === 'access token is not set permission denied!' ||
          msg === 'something wrong with request.'
        ) {
          setTimeout(() => {
            this.auth.logout();
            this.router.navigateByUrl('/signin', { replaceUrl: true });
          }, 500);
        }

        return throwError(() => error);
      }),

      finalize(() => {
        if (disableloader !== 'true') {
          this.ngxService.stop();   // STOP loader ONLY HERE
        }
      })
    );
  }

  loaderStart() {
    try {
      this.ngxService.start();
    } catch (error) {

    }
  }
  loaderDismiss() {
    try {
      // this.loadingCntr.dismiss();
      this.ngxService.stop();
    } catch (error) {

    }
  }
}
